import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { HelpService } from '@core/services/help.service';
import { HelpArticle } from '@app/shared/models/help-article.model';
import { ENDPOINTS } from '@core/constants/endpoints';
import { catchError, map, startWith } from 'rxjs/operators';
import { WindowRefService } from '@core/services/helpers/window-ref.service';

@Component({
    selector: 'app-help-side-panel',
    templateUrl: './help-side-panel.component.html',
    styleUrls: ['./help-side-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HelpSidePanelComponent {
    @Input() isMobile = false;
    @Input() defaultArticle = 'default';

    articlesList$: Observable<{
        isLoading: boolean;
        showError: boolean;
        list?: HelpArticle[];
    }>;
    currentArticle: HelpArticle;
    history: HelpArticle[] = [];
    links = {
        powerMonitoring: ENDPOINTS.helpCenter.base,
        gettingStarted: ENDPOINTS.helpCenter.gettingStarted,
        mailto: 'crosslab.support@agilent.com',
    };

    constructor(private helpService: HelpService, private windowRefService: WindowRefService) {
        this.articlesList$ = combineLatest([
            this.helpService.isLoading$,
            this.helpService.articles$,
        ]).pipe(
            map(([isLoading, list]) => ({
                isLoading,
                showError: false,
                list: isLoading ? undefined : list,
            })),
            catchError(() => {
                return of({
                    isLoading: false,
                    showError: true,
                    list: undefined,
                });
            }),
            startWith({
                isLoading: true,
                showError: false,
                list: undefined,
            })
        );
    }

    onOpenExternalLink(url: string) {
        this.windowRefService.window.open(url, '_blank');
    }

    close() {
        this.helpService.togglePanelVisibility();
    }
}
